var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourniquetSystemActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#5f9098"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4219 28.0859V39.6422L52.1272 35.1172H47.8728L37.5781 39.6422V28.0859H20V71.9141H37.5781V60.8984H37.9475L48.6116 56.2109H51.3884L62.0525 60.8984H62.4219V71.9141H80V28.0859H62.4219ZM34.0625 68.3984H23.5156V64.8828H28.2031V61.3672H23.5156V57.8516H28.2031V54.3359H23.5156V50.8203H28.2031V47.3047H23.5156V31.6016H34.0625V68.3984ZM37.5781 57.2203V43.4933L48.2422 38.7953V52.5356L37.5781 57.2203ZM51.7578 52.5356V38.7953L62.4219 43.4801V57.2203L51.7578 52.5356ZM76.4844 68.3984H65.9375V31.6016H76.4844V68.3984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9688 36.875C72.9688 37.8459 72.1819 38.6328 71.2109 38.6328C70.24 38.6328 69.4531 37.8459 69.4531 36.875C69.4531 35.9041 70.24 35.1172 71.2109 35.1172C72.1819 35.1172 72.9688 35.9041 72.9688 36.875ZM72.9688 43.9062C72.9688 44.8772 72.1819 45.6641 71.2109 45.6641C70.24 45.6641 69.4531 44.8772 69.4531 43.9062C69.4531 42.9353 70.24 42.1484 71.2109 42.1484C72.1819 42.1484 72.9688 42.9353 72.9688 43.9062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourniquetSystemActive);
export default __webpack_public_path__ + "static/media/tourniquetSystemActive.82f36ae88d9218f9ab74639090cc8967.svg";
export { ForwardRef as ReactComponent };